/**
 * Idle-session timings (API brief `tasks/prompt-auto-logout-dashboard.md`).
 *
 * The idle length itself comes from the API (`Authorization-Idle-Timeout`,
 * seconds, sent on every response that issues a token); the default only
 * covers an API that does not send it yet.
 */
export const MINUTE_MS = 60 * 1000;

export const DEFAULT_IDLE_TIMEOUT_MS = 30 * MINUTE_MS;

// The dialog opens this long before the idle timeout; its countdown runs
// down to the timeout itself.
export const WARNING_LEAD_MS = MINUTE_MS;

// "Active" for the keepalive and the pollers: an interaction within this
// window, capped by the idle timeout for short (test) configurations.
export const ACTIVE_WINDOW_MAX_MS = 5 * MINUTE_MS;

// Header values are measured when the API writes the response and are
// already a little stale on arrival; deadlines are shortened by this.
export const HEADER_MARGIN_MS = 10 * 1000;

// Without `Authorization-Token-Expires-In` (old API) the keepalive runs
// on a fixed cadence while the user is active.
export const FALLBACK_KEEPALIVE_MS = 5 * MINUTE_MS;

export const KEEPALIVE_CHECK_MS = 30 * 1000;
export const TICK_MS = 1000;
export const TOUCH_THROTTLE_MS = 1000;

export const SESSION_HEADERS = {
  tokenExpiresIn: 'Authorization-Token-Expires-In',
  sessionExpiresIn: 'Authorization-Expires-In',
  idleTimeout: 'Authorization-Idle-Timeout',
  // Deprecated absolute timestamp; still the sign of an authenticated
  // response on an API that predates the three above.
  legacyExpires: 'Authorization-Expires',
};

export const IDLE_STORAGE_KEYS = {
  lastInteractionAt: 'qhs:idle:lastInteractionAt',
  tokenDeadlineAt: 'qhs:idle:tokenDeadlineAt',
  idleTimeoutMs: 'qhs:idle:timeoutMs',
  lastKeepaliveAt: 'qhs:idle:lastKeepaliveAt',
};

// The login-page hash of the logout in progress, left for the other tabs
// of the session (they learn about the logout from the `isLogin` key).
// Not part of `clearIdleStore`: the tabs read it after the clear.
export const LOGOUT_HASH_STORAGE_KEY = 'qhs:idle:logoutHash';

// Written by the user slice (`setIsLoginToStorage`); the idle hook
// listens to it so a logout in one tab reaches the others.
export const IS_LOGIN_STORAGE_KEY = 'isLogin';
